!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.mailgo = t() : e.mailgo = t();
}(window, function () {
  return function (e) {
    var t = {};

    function o(a) {
      if (t[a]) return t[a].exports;
      var n = t[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, a) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: a
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var a = Object.create(null);
      if (o.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        o.d(a, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return a;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 0);
  }([function (e, t, o) {
    "use strict";

    !function () {
      function e() {
        var e = document.createElement("div");
        e.style.display = "none", e.id = "mailgo", e.classList.add("m-modal");
        var t = document.createElement("div");
        t.className = "m-modal-back", e.appendChild(t);
        var o = document.createElement("div");
        o.className = "m-modal-content", e.appendChild(o), (d = document.createElement("strong")).id = "m-title", d.className = "m-title", o.appendChild(d);
        var a = document.createElement("div");
        a.id = "m-details", a.className = "m-details", (c = document.createElement("p")).id = "m-cc";
        var n = document.createElement("span");
        n.className = "w-500";
        var E = document.createTextNode("cc ");
        n.appendChild(E), (s = document.createElement("span")).id = "m-cc-value", c.appendChild(n), c.appendChild(s), a.appendChild(c), (l = document.createElement("p")).id = "m-bcc";
        var L = document.createElement("span");
        L.className = "w-500";
        var N = document.createTextNode("bcc ");
        L.appendChild(N), (p = document.createElement("span")).id = "m-bcc-value", l.appendChild(L), l.appendChild(p), a.appendChild(l), (r = document.createElement("p")).id = "m-subject";
        var T = document.createElement("span");
        T.className = "w-500";
        var z = document.createTextNode("subject ");
        T.appendChild(z), (u = document.createElement("span")).id = "m-subject-value", r.appendChild(T), r.appendChild(u), a.appendChild(r), (m = document.createElement("p")).id = "m-body";
        var A = document.createElement("span");
        A.className = "w-500";
        var S = document.createTextNode("body ");
        A.appendChild(S), (b = document.createElement("span")).id = "m-body-value", m.appendChild(A), m.appendChild(b), a.appendChild(m), o.appendChild(a), (f = document.createElement("a")).id = "m-gmail", f.href = j, f.classList.add("m-open"), f.classList.add("m-gmail");
        var R = document.createTextNode("open in ");
        f.appendChild(R);
        var U = document.createElement("span");
        U.className = "w-500";
        var I = document.createTextNode("Gmail");
        U.appendChild(I), f.appendChild(U), o.appendChild(f), (h = document.createElement("a")).id = "m-outlook", h.href = j, h.classList.add("m-open"), h.classList.add("m-outlook");
        var M = document.createTextNode("open in ");
        h.appendChild(M);

        var _ = document.createElement("span");

        _.className = "w-500";
        var O = document.createTextNode("Outlook");
        _.appendChild(O), h.appendChild(_), o.appendChild(h), (g = document.createElement("a")).id = "m-open", g.href = j, g.classList.add("m-open"), g.classList.add("m-default");
        var P = document.createElement("span");
        P.className = "w-500";
        var W = document.createTextNode("open");
        P.appendChild(W);
        var H = document.createTextNode(" default");
        g.appendChild(P), g.appendChild(H), o.appendChild(g), (C = document.createElement("a")).id = "m-copy", C.href = j, C.classList.add("m-copy"), C.classList.add("w-500");
        var D = document.createTextNode("copy");
        C.appendChild(D), o.appendChild(C), o.appendChild(X()), document.body.appendChild(e), t.addEventListener("click", Q);
        var B = document.createElement("div");
        B.style.display = "none", B.id = "mailgo-tel", B.classList.add("m-modal");
        var Z = document.createElement("div");
        Z.className = "m-modal-back", B.appendChild(Z);
        var F = document.createElement("div");
        F.className = "m-modal-content", B.appendChild(F), (i = document.createElement("strong")).id = "m-tel-title", i.className = "m-title", F.appendChild(i), (x = document.createElement("a")).id = "m-tg", x.href = j, x.classList.add("m-open"), x.classList.add("m-tg"), x.style.display = "none";
        var G = document.createTextNode("open in ");
        x.appendChild(G);
        var $ = document.createElement("span");
        $.className = "w-500";
        var q = document.createTextNode("Telegram");
        $.appendChild(q), x.appendChild($), F.appendChild(x), (v = document.createElement("a")).id = "m-wa", v.href = j, v.classList.add("m-open"), v.classList.add("m-wa");
        var J = document.createTextNode("open in ");
        v.appendChild(J);
        var K = document.createElement("span");
        K.className = "w-500";
        var V = document.createTextNode("WhatsApp");
        K.appendChild(V), v.appendChild(K), F.appendChild(v), (w = document.createElement("a")).id = "m-skype", w.href = j, w.classList.add("m-open"), w.classList.add("m-skype");
        var Y = document.createTextNode("open in ");
        w.appendChild(Y);
        var ee = document.createElement("span");
        ee.className = "w-500";
        var te = document.createTextNode("Skype");
        ee.appendChild(te), w.appendChild(ee), F.appendChild(w), (y = document.createElement("a")).id = "m-call", y.href = j, y.classList.add("m-open"), y.classList.add("m-default");
        var oe = document.createElement("span");
        oe.className = "w-500";
        var ae = document.createTextNode("call");
        oe.appendChild(ae);
        var ne = document.createTextNode(" as default");
        y.appendChild(oe), y.appendChild(ne), F.appendChild(y), (k = document.createElement("a")).id = "m-tel-copy", k.href = j, k.classList.add("m-copy"), k.classList.add("w-500");
        var de = document.createTextNode("copy");
        k.appendChild(de), F.appendChild(k), F.appendChild(X()), document.body.appendChild(B), Z.addEventListener("click", Q);
      }

      function t(e, t) {
        var o = 0 < arguments.length && void 0 !== e ? e : T,
            a = 1 < arguments.length ? t : void 0;

        if (o === T) {
          if (a.href && a.href.toLowerCase().startsWith(E)) {
            S = decodeURIComponent(a.href.split("?")[0].split(E)[1].trim()), A = new URL(a.href);
            var n = new URLSearchParams(A.search);
            U = n.get("cc"), I = n.get("bcc"), M = n.get("subject"), _ = n.get("body");
          } else S = a.getAttribute("data-address") + "@" + a.getAttribute("data-domain"), A = new URL(E + encodeURIComponent(S)), U = a.getAttribute("data-cc-address") + "@" + a.getAttribute("data-cc-domain"), I = a.getAttribute("data-bcc-address") + "@" + a.getAttribute("data-bcc-domain"), M = a.getAttribute("data-subject"), _ = a.getAttribute("data-body");

          if (!de(S.split(","))) return;
          U && !de(U.split(",")) && (U = ""), I && !de(I.split(",")) && (I = ""), d.innerHTML = S.split(",").join("<br/>"), U ? (c.style.display = "block", s.innerHTML = U.split(",").join("<br/>")) : c.style.display = "none", I ? (l.style.display = "block", p.innerHTML = I.split(",").join("<br/>")) : l.style.display = "none", M ? (r.style.display = "block", u.textContent = M) : r.style.display = "none", _ ? (m.style.display = "block", b.textContent = _) : m.style.display = "none", f.addEventListener("click", H), h.addEventListener("click", D), R = ee(S), g.addEventListener("click", B), C.addEventListener("click", function () {
            return q(S);
          });
        }

        o === z && (a.href && a.href.toLowerCase().startsWith(L) ? O = decodeURIComponent(a.href.split("?")[0].split(L)[1].trim()) : a.href && a.href.toLowerCase().startsWith(N) ? O = decodeURIComponent(a.href.split("?")[0].split(N)[1].trim()) : a.hasAttribute("data-tel") && (O = a.getAttribute("data-tel"), a.getAttribute("data-msg")), a.hasAttribute("data-telegram") && (P = a.getAttribute("data-telegram")), a.hasAttribute("data-skype") && (W = a.getAttribute("data-skype")), i.innerHTML = O, v.addEventListener("click", G), P && (ae("m-tg", "block"), x.addEventListener("click", Z)), w.addEventListener("click", F), y.addEventListener("click", $), k.addEventListener("click", function () {
          return q(O);
        })), K(o), document.addEventListener("keydown", J);
      }

      function o(e, t) {
        var o = 1 < arguments.length && void 0 !== t ? t : T;
        return o === T ? e.href && e.href.toLowerCase().startsWith(E) && !e.classList.contains("no-mailgo") || e.hasAttribute("data-address") && (e.href && "#mailgo" === e.getAttribute("href").toLowerCase() || e.classList && e.classList.contains("mailgo")) : o === z && (e.href && (e.href.toLowerCase().startsWith(L) || e.href.toLowerCase().startsWith(N)) && !e.classList.contains("no-mailgo") || e.hasAttribute("data-tel") && e.href && "#mailgo" === e.getAttribute("href").toLowerCase() || e.classList && e.classList.contains("mailgo"));
      }

      function a(e) {
        if (document.contains(te("mailgo")) && document.contains(te("mailgo-tel")) && !V(T) && !V(z)) {
          var a = e.path || e.composedPath && e.composedPath() || ne(e.target);
          a && a.forEach(function (a) {
            if (!(a instanceof HTMLDocument || a instanceof Window)) return o(a, T) ? (e.preventDefault(), void t(T, a)) : o(a, z) ? (e.preventDefault(), void t(z, a)) : void 0;
          });
        }
      }

      function n(e) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e);
      }

      var d,
          i,
          c,
          l,
          r,
          m,
          s,
          p,
          u,
          b,
          f,
          h,
          g,
          x,
          v,
          w,
          y,
          C,
          k,
          E = "mailto:",
          L = "tel:",
          N = "callto:",
          T = "mail",
          z = "tel",
          j = "javascript:void(0);",
          A = "",
          S = "",
          R = "",
          U = "",
          I = "",
          M = "",
          _ = "",
          O = "",
          P = "",
          W = "",
          H = function H() {
        var e = "https://mail.google.com/mail/u/0/?view=cm&source=mailto&to=" + encodeURIComponent(S);
        U && (e = e.concat("&cc=" + encodeURIComponent(U))), I && (e = e.concat("&bcc=" + encodeURIComponent(I))), M && (e = e.concat("&subject=" + M)), _ && (e = e.concat("&body=" + _)), window.open(e, "_blank"), Q();
      },
          D = function D() {
        var e = "https://outlook.live.com/owa/?path=/mail/action/compose&to=" + encodeURIComponent(S);
        M && (e = e.concat("&subject=" + M)), _ && (e = e.concat("&body=" + _)), window.open(e, "_blank"), Q();
      },
          B = function B() {
        Y(R), Q();
      },
          Z = function Z() {
        var e = "https://t.me/" + P;
        window.open(e, "_blank"), Q();
      },
          F = function F() {
        var e = "skype:" + ("" !== W ? W : O);
        window.open(e, "_blank"), Q();
      },
          G = function G() {
        var e = "https://wa.me/" + O;
        window.open(e, "_blank"), Q();
      },
          $ = function $() {
        var e = "tel:" + O;
        window.open(e), Q();
      },
          q = function q(e) {
        var t;
        ie(e), (t = V(T) ? C : k).textContent = "copied", setTimeout(function () {
          t.textContent = "copy", Q();
        }, 999);
      },
          J = function J(e) {
        if (V(T)) switch (e.keyCode) {
          case 27:
            Q();
            break;

          case 71:
            H();
            break;

          case 79:
            D();
            break;

          case 32:
          case 13:
            B();
            break;

          case 67:
            q(S);
            break;

          default:
            return;
        } else if (V(z)) switch (e.keyCode) {
          case 27:
            Q();
            break;

          case 84:
            Z();
            break;

          case 87:
            G();
            break;

          case 32:
          case 13:
            $();
            break;

          case 67:
            q(O);
            break;

          default:
            return;
        }
      },
          K = function K(e) {
        var t = 0 < arguments.length && void 0 !== e ? e : T;
        t !== T ? t !== z || ae("mailgo-tel", "flex") : ae("mailgo", "flex");
      },
          Q = function Q() {
        ae("mailgo", "none"), ae("mailgo-tel", "none"), document.removeEventListener("keydown", J);
      },
          V = function V(e) {
        var t = 0 < arguments.length && void 0 !== e ? e : T;
        return t === T ? "flex" === oe("mailgo") : t === z && "flex" === oe("mailgo-tel");
      },
          X = function X() {
        var e = document.createElement("a");
        e.href = "https://mailgo.js.org?ref=mailgo-modal", e.className = "m-by", e.target = "_blank", e.rel = "noopener noreferrer";
        var t = document.createTextNode("mailgo.js.org");
        return e.appendChild(t), e;
      },
          Y = function Y(e) {
        return window.location.href = E + atob(e);
      },
          ee = function ee(e) {
        return btoa(e);
      },
          te = function te(e) {
        return document.getElementById(e);
      },
          oe = function oe(e) {
        return te(e).style.display;
      },
          ae = function ae(e, t) {
        return te(e).style.display = t;
      },
          ne = function ne(e) {
        for (var t = []; e;) {
          if (t.push(e), "HTML" === e.tagName) return t.push(document), t.push(window), t;
          e = e.parentElement;
        }
      },
          de = function de(e) {
        return e.every(n);
      },
          ie = function ie(e) {
        var t = document.createElement("textarea");
        t.value = e, t.setAttribute("readonly", ""), t.style.position = "absolute", t.style.left = "-9999px", document.body.appendChild(t);
        var o = 0 < document.getSelection().rangeCount && document.getSelection().getRangeAt(0);
        t.select(), document.execCommand("copy"), document.body.removeChild(t), o && (document.getSelection().removeAllRanges(), document.getSelection().addRange(o));
      };

      !function () {
        if (window && "undefined" != typeof window) {
          var t = document.createElement("style");
          t.id = "mailgo-style", t.type = "text/css";
          var o = document.createTextNode('.m-modal{position:fixed;top:0;right:0;bottom:0;left:0;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden;font-size:15px;z-index:10000}.m-modal a,.m-modal p,.m-modal span,.m-modal strong{margin:0;padding:0;font-size:100%;line-height:1;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";text-rendering:optimizeLegibility}.m-modal strong{font-weight:700}.m-modal .m-modal-back{position:absolute;z-index:10001;top:0;right:0;bottom:0;left:0;background-color:rgba(32,35,42,.75);opacity:.8}.m-modal .m-modal-content{position:relative;z-index:10002;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;text-align:center;min-width:200px;max-width:240px;background-color:#fff;opacity:.97;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;-webkit-box-shadow:0 3px 20px rgba(32,35,42,.5);-moz-box-shadow:0 3px 20px rgba(32,35,42,.5);box-shadow:0 3px 20px rgba(32,35,42,.5);color:#4a4a4a;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto;padding:20px;-webkit-transition:.5s -webkit-box-shadow;transition:.5s -webkit-box-shadow;-o-transition:.5s box-shadow;-moz-transition:.5s box-shadow,.5s -moz-box-shadow;transition:.5s box-shadow;transition:.5s box-shadow,.5s -webkit-box-shadow,.5s -moz-box-shadow}.m-modal .m-modal-content:hover{opacity:1;-webkit-box-shadow:0 7px 20px rgba(32,35,42,.85);-moz-box-shadow:0 7px 20px rgba(32,35,42,.85);box-shadow:0 7px 20px rgba(32,35,42,.85)}.m-modal .m-modal-content .m-title{margin-bottom:8px;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis}.m-modal .m-modal-content .m-details{margin-bottom:10px}.m-modal .m-modal-content .m-details p{font-size:12px;margin-top:3px;margin-bottom:3px}.m-modal .m-modal-content a{padding:10px;color:#4a4a4a;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;text-decoration:none}.m-modal .m-modal-content a.m-gmail{color:#d44638}.m-modal .m-modal-content a.m-gmail:hover{background-color:rgba(212,70,56,.08);color:#d44638}.m-modal .m-modal-content a.m-outlook{color:#0072c6}.m-modal .m-modal-content a.m-outlook:hover{background-color:rgba(0,114,198,.08);color:#0072c6}.m-modal .m-modal-content a.m-tg{color:#08c}.m-modal .m-modal-content a.m-tg:hover{background-color:rgba(0,114,198,.08);color:#08c}.m-modal .m-modal-content a.m-wa{color:#00bfa5}.m-modal .m-modal-content a.m-wa:hover{background-color:rgba(0,191,165,.08);color:#00bfa5}.m-modal .m-modal-content a.m-skype{color:#00aff0}.m-modal .m-modal-content a.m-skype:hover{background-color:rgba(0,175,240,.08);color:#00aff0}.m-modal .m-modal-content a.m-copy{padding:16px 10px;font-size:16px}.m-modal .m-modal-content a.m-copy:hover,.m-modal .m-modal-content a.m-default:hover{background-color:rgba(0,0,0,.08);color:#4a4a4a}.m-modal .m-modal-content a.m-by{font-size:8px;margin-top:.8rem;padding:5px;color:#4a4a4a;opacity:.5}.m-modal .m-modal-content a.m-by:hover{opacity:1}.m-modal .m-modal-content .w-500{font-weight:500}');
          t.appendChild(o), document.head.appendChild(t), document.addEventListener("DOMContentLoaded", e), document.addEventListener("click", a);
        }
      }();
    }();
  }]);
});